/**
 * The base delay (in milliseconds) used for retry or polling intervals.
 */
export const BASE_DELAY = 1_000;

/**
 * The name of the channel used for SSE (Server-Sent Events) coordination.
 */
export const CHANNEL_NAME = 'sse-coordination';

/**
 * The timeout duration in milliseconds used for election processes.
 * This constant defines how long the system should wait before considering
 * an election as timed out, typically used in distributed systems or
 * leader election algorithms.
 *
 * @remarks
 * Adjust this value based on the responsiveness and requirements of your system.
 *
 * @defaultValue 150
 */
export const ELECTION_TIMEOUT_MS = 150;

/**
 * The interval, in milliseconds, at which the follower check operation is performed.
 * Used to periodically verify the status or presence of a follower in the SSE context.
 *
 * @defaultValue 2000
 */
export const FOLLOWER_CHECK_INTERVAL = 2000;

/**
 * The event name for heartbeat messages sent over SSE.
 */
export const HEARTBEAT_EVENT = 'heartbeat';

/**
 * The timeout duration (in milliseconds) to wait for a heartbeat event before considering the connection lost.
 */
export const HEARTBEAT_TIMEOUT = 30_000;

/**
 * The interval, in milliseconds, at which the leader sends ping messages.
 * Used to maintain connectivity or check the status of the leader in SSE (Server-Sent Events) contexts.
 */
export const LEADER_PING_INTERVAL = 2000;

/**
 * The timeout duration (in milliseconds) used to determine the leader in an SSE (Server-Sent Events) context.
 * If no leader activity is detected within this period, a new leader election may be triggered.
 */
export const LEADER_TIMEOUT = 6000;

/**
 * The maximum delay (in milliseconds) allowed for retry or polling intervals.
 */
export const MAX_DELAY = 64_000;

/**
 * The event name for triggering a resynchronization over SSE.
 */
export const RESYNC_EVENT = 'resync';
